<template>
  <div class="map-section">
    <h2 class="title">Izložbeni prostor</h2>
    <div class="map-wrapper">
      <div class="map">
        <img src="@/assets/app-icons/map/map.jpg" />
      </div>
      <div class="legend">
        <img src="@/assets/app-icons/map/legend.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapSection',
};
</script>

<style scoped>
.map-section {
  margin-top: 120px;
}

.title {
  font-size: 24px;
  line-height: 36px;
  margin-top: 0;
  margin-bottom: 16px;
}

.map-wrapper {
  display: flex;
  flex-direction: column;
}

.map img {
  max-width: 100%;
  margin-bottom: 16px;
}

.legend {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 10px;
}

.legend img {
  max-width: 80%;
}

@media only screen and (min-width: 768px) {
  .map-wrapper {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }

  .map {
    flex-basis: 60%;
  }

  .map img {
    margin-bottom: 0;
  }

  .legend-wrapper {
    flex-basis: 30%;
  }
}
</style>
